import types from './types';

const getInventoryHistory = id => ({
  type: types.GET_INVENTORY_HISTORY,
  params: { id }
});

const getInitialData = id => ({
  type: types.GET_INITIAL_DATA,
  params: { id }
});

export default {
  getInventoryHistory,
  getInitialData
};
